import React, { useEffect } from "react";
import "./App.css";
// Remember the acquisition channel (?ref=instagram|facebook|google…) for the whole visit
try { const _r = new URLSearchParams(window.location.search).get("ref"); if (_r && /^[a-z0-9_-]{1,40}$/i.test(_r)) sessionStorage.setItem("pozzo_ref", _r.toLowerCase()); } catch (_) { /* no storage */ }
import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import MenuIndexPage from "./pages/MenuIndexPage";
import MenuPage from "./pages/MenuPage";
import AdminPage from "./pages/AdminPage";
import GuestDocsUploadPage from "./pages/GuestDocsUploadPage";
import SpaBookingPage from "./pages/SpaBookingPage";
import PrenotaPage from "./pages/PrenotaPage";
import MassageBookingPage from "./pages/MassageBookingPage";
import RoomPage from "./pages/RoomPage";
import TvLoopPage from "./pages/TvLoopPage";
import HorseRidePage from "./pages/HorseRidePage";
import POIsPage from "./pages/POIsPage";
import LoyaltyPage from "./pages/LoyaltyPage";
import LegalPage from "./pages/LegalPage";
import QuoteRequestPage from "./pages/QuoteRequestPage";
import QuotePublicPage from "./pages/QuotePublicPage";
import PayRequestPage from "./pages/PayRequestPage";
import BikeIntroPage from "./pages/BikeIntroPage";
import HousekeepingPage from "./pages/housekeeping/HousekeepingPage";
import HousekeeperOnlyPage from "./pages/housekeeping/HousekeeperOnly";
import CheckinPage from "./pages/CheckinPage";
import SalaPage from "./pages/SalaPage";
import PrenotazioniPage from "./pages/PrenotazioniPage";
import AmbientiPage from "./pages/AmbientiPage";
import ExperiencePage from "./pages/ExperiencePage";
import TakeawayPage from "./pages/TakeawayPage";
import TakeawaySuccessPage from "./pages/TakeawaySuccessPage";
import ShopPage from "./pages/ShopPage";
import ShopSuccessPage from "./pages/ShopSuccessPage";
import RunnerPage from "./pages/RunnerPage";
import SocialPage from "./pages/SocialPage";
import SocialPlanPage from "./pages/SocialPlanPage";
import StaffPage from "./pages/StaffPage";
import GiftPage from "./pages/GiftPage";
import GiftSuccessPage from "./pages/GiftSuccessPage";
import GiftVoucherPage from "./pages/GiftVoucherPage";
import BreakfastVoucherPage from "./pages/BreakfastVoucherPage";
import RadioReceiverPage from "./pages/RadioReceiverPage";
import QrPositionsPage from "./pages/QrPositionsPage";
import PWAManager from "./components/PWAManager";

// If a user lands on the home with "admin" in the query string (e.g. bad share link
// like "?utm_source=share/admin"), automatically redirect to /admin.
function AdminQueryRedirect({ children }) {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname !== "/") return;
    const raw = location.search || "";
    const hash = location.hash || "";
    const combined = (raw + hash).toLowerCase();
    if (combined.includes("admin")) {
      navigate("/admin", { replace: true });
    }
  }, [location.pathname, location.search, location.hash, navigate]);

  return children;
}

function App() {
  // Keep <html lang="…"> in sync with the app's selected language.
  // Prevents mobile browsers (Chrome / Safari Translate) from mis-detecting
  // the page language and offering to translate the UI — which caused
  // "IT" → "ESSO" and other regressions with our own i18n system.
  useEffect(() => {
    const apply = () => {
      const l = localStorage.getItem("lang") || "it";
      if (document.documentElement.getAttribute("lang") !== l) {
        document.documentElement.setAttribute("lang", l);
      }
    };
    apply();
    window.addEventListener("storage", apply);
    // Some pages set `lang` without firing `storage` (same-tab). Poll gently.
    const t = setInterval(apply, 1500);
    return () => { window.removeEventListener("storage", apply); clearInterval(t); };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <PWAManager />
        <SubdomainRedirect />
        <AdminQueryRedirect>
          <Routes>
            <Route path="/" element={<HomeByHost />} />
            <Route path="/menu/:menuId" element={<MenuPage />} />
            <Route path="/spa" element={<SpaBookingPage />} />
            <Route path="/documenti/:token" element={<GuestDocsUploadPage />} />
            <Route path="/prenota" element={<PrenotaPage />} />
            <Route path="/regala" element={<GiftPage />} />
            <Route path="/regala/success" element={<GiftSuccessPage />} />
            <Route path="/regalo/:code" element={<GiftVoucherPage />} />
            <Route path="/colazione/:code" element={<BreakfastVoucherPage />} />
            <Route path="/radio" element={<RadioReceiverPage />} />
            <Route path="/radio/:zone" element={<RadioReceiverPage />} />
            <Route path="/qr-posti" element={<QrPositionsPage />} />
            <Route path="/massaggi" element={<MassageBookingPage />} />
            <Route path="/room/bestrla" element={<Navigate to="/room/bestla" replace />} />
            <Route path="/room/:slug" element={<RoomPage />} />
            <Route path="/tv-loop" element={<TvLoopPage />} />
            <Route path="/cavallo" element={<HorseRidePage />} />
            <Route path="/bici" element={<BikeIntroPage />} />
            <Route path="/dintorni" element={<POIsPage />} />
            <Route path="/fidelity" element={<LoyaltyPage />} />
            <Route path="/privacy" element={<LegalPage doc="privacy" />} />
            <Route path="/preventivo" element={<QuoteRequestPage />} />
            <Route path="/preventivo/:token" element={<QuotePublicPage />} />
            <Route path="/paga/:token" element={<PayRequestPage />} />
            <Route path="/cookie" element={<LegalPage doc="cookie" />} />
            <Route path="/termini" element={<LegalPage doc="termini" />} />
            <Route path="/fidelity-app" element={<LoyaltyPage showSubNav />} />
            <Route path="/loyalty" element={<LoyaltyPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/admin/pulizie/*" element={<HousekeepingPage />} />
            <Route path="/pulizie" element={<HousekeeperOnlyPage />} />
            <Route path="/checkin" element={<CheckinPage />} />
            <Route path="/ristorante" element={<SalaPage />} />
            <Route path="/prenotazioni" element={<PrenotazioniPage />} />
            <Route path="/ambienti" element={<AmbientiPage />} />
            <Route path="/eventi/:id" element={<ExperiencePage />} />
            <Route path="/asporto" element={<TakeawayPage />} />
            <Route path="/asporto-app" element={<TakeawayPage appMode />} />
            <Route path="/asporto/success" element={<TakeawaySuccessPage />} />
            <Route path="/asporto/cancel" element={<Navigate to="/asporto" replace />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/shop-app" element={<ShopPage appMode />} />
            <Route path="/shop/success" element={<ShopSuccessPage />} />
            <Route path="/shop/cancel" element={<Navigate to="/shop" replace />} />
            <Route path="/runner" element={<RunnerPage />} />
            <Route path="/social" element={<SocialPage />} />
            <Route path="/social/plan" element={<SocialPlanPage />} />
            <Route path="/team" element={<StaffPage />} />
            <Route path="/staff" element={<StaffPage />} />
            <Route path="/eventi" element={<Navigate to="/dintorni" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AdminQueryRedirect>
      </BrowserRouter>
    </div>
  );
}

export default App;

// ---------- Subdomain detection helpers ----------
// asporto.ilpozzodeigiganti.it → /asporto  (renders TakeawayPage at "/")
// shop.ilpozzodeigiganti.it    → /shop     (renders ShopPage at "/")
// menu.ilpozzodeigiganti.it    → /          (renders MenuIndexPage — default)
function currentSub() {
  if (typeof window === "undefined") return null;
  const host = (window.location.hostname || "").toLowerCase();
  if (host.startsWith("asporto.")) return "asporto";
  if (host.startsWith("shop.")) return "shop";
  return null;
}

function HomeByHost() {
  const sub = currentSub();
  if (sub === "asporto") return <TakeawayPage />;
  if (sub === "shop") return <ShopPage />;
  return <MenuIndexPage />;
}

function SubdomainRedirect() {
  // Only intervene when the user is at "/" — subroutes work as-is (a link
  // to /admin from asporto.ilpozzodeigiganti.it must still open admin).
  React.useEffect(() => {
    const sub = currentSub();
    if (!sub) return;
    const p = window.location.pathname;
    // If they navigate manually to /asporto on the asporto sub-domain, silently
    // rewrite to "/" so the nav bar looks clean (still same page).
    if (sub === "asporto" && p === "/asporto") {
      window.history.replaceState({}, "", "/");
    } else if (sub === "shop" && p === "/shop") {
      window.history.replaceState({}, "", "/");
    }
  }, []);
  return null;
}
